import { createFileRoute } from "@tanstack/react-router";
import { MediaPage } from "../../components/media";
import { MediaType } from "../../generated/graphql";

export const Route = createFileRoute("/media/audio")({
  component: AudioPage,
});

function AudioPage() {
  return <MediaPage mediaType={MediaType.Audio} basePath="/media/audio" />;
}
